import { Modal, ModalBody, ModalFooter } from "reactstrap";
import { connect } from "react-redux";

const ModalPreview = ({ isOpen, onClose, previewLink }) => {
    return (
            <Modal
                centered={true}
                toggle={() => {
                    onClose();
                }}
                isOpen={isOpen}
            >
                <div className="modal-header">
                    <h2 className="mb-0 text-info">Video</h2>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal">
                        <i
                            className="ki-outline ki-cross fs-1"
                            onClick={() => {
                                onClose();
                            }}
                        ></i>
                    </div>
                </div>
                <ModalBody>
                    <div style={{ height: "100vh", maxHeight: "750px" }} className="d-flex justify-content-between">
                        <iframe src={previewLink} title="tiktok video" className="h-100 w-100" />
                    </div>
                </ModalBody>
                <ModalFooter>
                    <button
                        type="reset"
                        id="kt_modal_users_search_reset"
                        data-bs-dismiss="modal"
                        className="btn btn-active-light me-3"
                        onClick={() => {
                            onClose();
                        }}
                    >
                        Cancel
                    </button>
                </ModalFooter>
            </Modal>
    );
};

export default connect(null, {})(ModalPreview);
